import { Suspense } from "react";
import { Outlet, ScrollRestoration, useLocation } from "react-router";

import { useNetworkErrorHandler } from "@/hooks/use-network-error-handler";

import { Toaster } from "@/components/features/side-effect/notify-user-event-info";
import { ShowLoadingScreenToUserProvider } from "@/components/features/side-effect/show-loading-screen-to-user";

import { CircleLoadingScreen } from "@/components/ui/loading/circle-screen";

export const RootLayout = () => {
	const { key } = useLocation();

	useNetworkErrorHandler();

	return (
		<div className="min-h-screen min-w-full">
			<Toaster />
			<Suspense key={key} fallback={<CircleLoadingScreen />}>
				<ShowLoadingScreenToUserProvider>
					<Outlet />
					<ScrollRestoration
						getKey={({ hash }) => {
							// hashが存在する場合は、hashが変更された場合にScrollRestorationが無効になる
							return hash ?? null;
						}}
					/>
				</ShowLoadingScreenToUserProvider>
			</Suspense>
		</div>
	);
};

RootLayout.displayName = "RootLayout";
